import React from 'react'
import CarouselCSS from "./Carousel.module.css"
import Cards from '../Cards/Cards';

export default function Carousel() {
  let projects = [
    {
      poster : "./images/yoox.png",
      name : "Yoox.com Clone",
      description : "A clone of an Italian e-commerce website. Where we can buy designer clothing for all, and also we can buy some special artists crafts.",
      techStack : [
        {img : "https://img.icons8.com/color/1x/html-5.png", title : "HTML 5"},
        {img : "https://img.icons8.com/fluency/1x/css3.png", title : "CSS 3"},
        {img : "https://img.icons8.com/color/1x/javascript.png", title : "JavaScript"},
        {img : "https://avatars.githubusercontent.com/u/2918581?s=280&v=4", title : "Bootstrap"},
        {img : "https://img.icons8.com/officel/1x/react.png", title : "React"},
      ],
      github : "https://github.com/bikramboss8055/mere-coast-376.git",
      live : "https://yoox-by-bikram-dutta.netlify.app/"
    },
    {
      poster : "./images/buffer.png",
      name : "Buffer.com Clone",
      description : "Buffer helps you build an audience organically. We’re a values-driven company that provides affordable, intuitive, marketing tools for ambitious people and teams.",
      techStack : [
        {img : "https://img.icons8.com/color/1x/html-5.png", title : "HTML 5"},
        {img : "https://img.icons8.com/fluency/1x/css3.png", title : "CSS 3"},
        {img : "https://img.icons8.com/color/1x/javascript.png", title : "JavaScript"},
        
      ],
      github : "https://github.com/Shivareddykyadari/max-oranges-6244",
      live : "https://buffercom-bikramdutta.netlify.app/"
    },
    {
      poster : "./images/fatsecret.png",
      name : "Fatsecret.com Clone",
      description : "An app to track your daily calorie and nutritional information. You can also track your weight loss journey.",
      techStack : [
        {img : "https://img.icons8.com/color/1x/html-5.png", title : "HTML 5"},
        {img : "https://img.icons8.com/fluency/1x/css3.png", title : "CSS 3"},
        {img : "https://img.icons8.com/color/1x/javascript.png", title : "JavaScript"},
      ],
      github : "https://github.com/bikramboss8055/scientific-ship-5992.git",
      live : "https://fatsecret-by-bikram-dutta.netlify.app/"
    },
    {
      poster : "./images/bigbasket.png",
      name : "Big Basket.com Clone",
      description : "An E-commerce website for daily household needs. Foods, snacks, housekeeping, medical and many more.",
      techStack : [
        {img : "https://img.icons8.com/officel/1x/react.png", title : "React JS"},
        {img : "https://img.icons8.com/color/1x/redux.png", title : "Redux"},
        {img : "https://img.icons8.com/color/1x/chakra-ui.png", title : "Chakra UI"},
        {img : "https://img.icons8.com/color/1x/html-5.png", title : "HTML 5"},
        {img : "https://img.icons8.com/fluency/1x/css3.png", title : "CSS 3"},
        {img : "https://img.icons8.com/color/1x/javascript.png", title : "JavaScript"},
      ],
      github : "https://github.com/Nikhil-81/big_basket",
      live : "https://bigbasket-gold.vercel.app/"
    }
  ]
  return (
    <>
     <div className={CarouselCSS.container}>

       {
        projects.map((ele) =>{
          return     <Cards {...ele}/>
        })
       }
     

     </div>
    </>
  )
}